import { Button, ButtonProps } from "antd";
import Icon from "../../assets/icons/icon";

interface CheckButtonProps extends ButtonProps {
  checked?: boolean;
}

export default function CheckButton({ checked, children, style, ...rest }: CheckButtonProps) {
  return (
    <Button {...rest}
      style={{
        ...style,
        boxShadow: "none",
        color: checked ? "#FFF" : "#5A6870",
        borderColor: checked ? "#1EC670" : undefined,
        backgroundColor: checked ? "#1EC670" : undefined
      }}
      icon={<Icon name={checked ? "check-circle-bold" : "radio-button-off-outline"} />}
    >
      {children}
    </Button>
  );
};
